// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"cdfc5e78","387":"4730b3a9","453":"8ef77292"}[chunkId] + ".chunk.js";
};